import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

interface CaptainVideoProps {
    videoUrl: string;
    onVideoEnd: () => void;
}

const CaptainVideo: React.FC<CaptainVideoProps> = ({
    videoUrl,
    onVideoEnd,
}) => {
    const playerContainerRef = useRef<HTMLDivElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);
    const [videoHeight, setVideoHeight] = useState(window.innerHeight);

    const handleFullScreenChange = () => {
        if (!document.fullscreenElement) {
            onVideoEnd();
        }
    };

    const handleResize = () => {
        setVideoHeight(window.innerHeight);
    };

    const handleScroll = () => {
        if (window.scrollY > 50) {
            videoRef.current?.pause();
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        document.addEventListener("fullscreenchange", handleFullScreenChange);
        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll);

        return () => {
            document.removeEventListener(
                "fullscreenchange",
                handleFullScreenChange
            );
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box
            ref={playerContainerRef}
            sx={{
                position: "relative",
                zIndex: 1,
                height: `${videoHeight}px`,
                overflow: "hidden",
                backgroundColor: "#000",
            }}
        >
            <video
                ref={videoRef}
                src={videoUrl}
                onPause={handleFullScreenChange}
                muted
                controls
                autoPlay
                onEnded={handleFullScreenChange}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </Box>
    );
};

export default CaptainVideo;
